
export const ObtenerCapitulos = () => {
    const data = new FormData();
    return new Promise((resolve, reject) => {
        fetch(process.env.REACT_APP_API_URL+'/capitulos.php?funcion=obtenerCapitulos',{
            method:'POST',
            body:data
        })
        .then(response => response.json())
        .then(datos => resolve(datos))

    })
    .then((datos) => {
        return datos
    })
    .catch(error => {
        console.warn(error);
        return error;
    })
}
export const GuardarCapitulo = (capitulo, descripcionCorta, idCapitulo) => {
    const data = new FormData();
    data.append('capitulo', capitulo)
    data.append('descripcionCorta', descripcionCorta)
    data.append('idCapitulo', idCapitulo)
    return new Promise((resolve, reject) => {
        fetch(process.env.REACT_APP_API_URL+'/capitulos.php?funcion=agregarCapitulo',{
            method:'POST',
            body:data
        })
        .then(response => response.json())
        .then(datos => resolve(datos))

    })
    .then((datos) => {
        return datos
    })
    .catch(error => {
        console.warn(error);
        return error;
    })
}
export const EliminarCapitulo = (idCapitulo) => {
    const data = new FormData();
    data.append('idCapitulo', idCapitulo)
    return new Promise((resolve, reject) => {
        fetch(process.env.REACT_APP_API_URL+'/capitulos.php?funcion=eliminarCapitulo',{
            method:'POST',
            body:data
        })
        .then(response => response.json())
        .then(datos => resolve(datos))

    })
    .then((datos) => {
        return datos
    })
    .catch(error => {
        console.warn(error);
        return error;
    })
}

